import React, { Component } from "react";
import { Segment, Button, Form, Table } from "semantic-ui-react";
import { CKEditor } from 'ckeditor4-react';

import request from "../../utils/request";
import { baseUrl } from "../../utils/constants";
import ResponseMessage from "../../components/common/ResponseMessage";
import { AppContext } from "../../utils/context";

CKEditor.editorUrl = `${baseUrl}/plugins/ckeditor/ckeditor.js`;

class CustomEmailBody extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      isLoading: true,
      content: "",
      xhrMessage: "",
      xhrStatus: "",
      shopifyStorefront: "",
      storefrontLists: null
    };
  }

  componentDidUpdate = prevProps => {
    if (this.props.match !== prevProps.match) {
      this.setState({
        isLoading: true,
        content: "",
        xhrMessage: "",
        xhrStatus: ""
      }, this.fetchData);
    }
  };

  componentDidMount = () => {
    if (this.props.match.params.method == "shopifyticketemail") {
      let storeFronts = [];
      this.context.settings.shopify_storefronts && this.context.settings.shopify_storefronts.forEach(store => {
        storeFronts.push({
          text: store.replace(/\/$/, ""),
          value: store.replace(/\/$/, "")
        });
      });
      this.setState({ storefrontLists: storeFronts });
      if (this.state.shopifyStorefront == "" && storeFronts.length > 0) {
        this.setState({ shopifyStorefront: storeFronts[0].value });
      }
    }
    this.fetchData();
  };

  componentWillUnmount = () => {
    this.setState({
      isLoading: true,
      content: "",
      xhrMessage: "",
      xhrStatus: ""
    });
  };

  startLoading = () => {
    this.setState({ isLoading: true });
  };

  doneLoading = () => {
    this.setState({ isLoading: false });
  };

  fetchData = async () => {
    this.startLoading();
    const currentPage = this.props.match.params.method;
    const shopifyDomain = this.state.shopifyStorefront;
    const params = shopifyDomain ? { shopifyDomain } : {};

    const response = await request.list(this, `api:/content/customize-emails/${currentPage}`, params);

    const content = response && response.data ? response.data.trim() : "";
    this.setState({ content }, this.doneLoading);
  };

  handleStoreSelected = async (e, { value }) => {
    if (this.state.shopifyStorefront != value) {
      this.setState({ shopifyStorefront: value }, this.fetchData);
    }
  }

  handleChange = e => {
    this.setState({ content: e.editor.getData() });
  };

  handleSubmit = () => {
    this.startLoading();
    let currentPage = this.props.match.params.method;
    let payload = {
      content: this.state.content,
      shopify_domain : currentPage == "shopifyticketemail" ? this.state.shopifyStorefront: null
    };
    this.setState({
      isLoading: true,
      xhrStatus: "",
      xhrMessage: ""
    });
    return request.put(this, `api:/content/customize-emails/${currentPage}`, payload).then(resp => {
      this.setState(
        {
          xhrStatus: resp.success ? "success" : "error",
          xhrMessage: resp.message
        },
        this.doneLoading
      );
      if (resp.success) {
        setTimeout(() => this.setState({ xhrStatus: '', xhrMessage: '' }), 4000);
      }
    });
  };

  handleDismissPortal = () => {
    if (this.state.xhrStatus === '') return null;
    this.setState({ xhrStatus: '', xhrMessage: '' });
  }

  render() {
    const { content, isLoading, xhrMessage, xhrStatus, shopifyStorefront, storefrontLists} = this.state;
    const { location } = this.props;
    let showSubscriptionId = true;
    if (location.pathname.includes("error") ||
        location.pathname.includes("refund") ||
        location.pathname.includes("recipients")) {
            showSubscriptionId = false;
    }

    const currentPage = this.props.match.params.method;
    let initialContent = "";
    if (currentPage === "shopifyticketemail") {
      let jurisdictionString = +this.context.settings.general.display_jurisdiction ? '<p style="text-align: center;">Tickets sold in: [jurisdiction]</p>' : '';

      const defaultContent = `
      <h1 style="text-align: center;">EXAMPLE SHOPIFY EMAIL TEMPLATE</h1>
      <p>--start-event-content--</p>
      <hr />
      <h1 style="text-align: center;">#[event_id] [event_title]</h1>
      <h2 style="text-align: center;">DRAW DATE: [event_draw_date_text]</h2>
      <p>--start-ticket-content--</p>
      <p style="text-align: center;">Date Issued: [order_issue_date]</p>
      ${jurisdictionString}
      <div style="border-style: solid; border-width: 1px; border-color: black; border-radius: 5px; margin: 5px; padding: 5px;">
      <p style="text-align: center;"><strong>$[price]</strong></p>
      <p style="text-align: center;"><strong>REFERENCE: #[shopify_order_reference]</strong></p>
      <p style="text-align: center;"><strong>Your Raffle Number(s):</strong></p>
      <p style="text-align: center;">--ticket-number--</p>
      </div>
      <p>--end-ticket-content--</p>
      <h1 style="text-align: center;">Draw Information</h1>
      <h3 style="text-align: left;">[game_type]</h3>
      <h3 style="text-align: left;">DRAW DATE: [event_draw_date_text]</h3>
      <h3 style="text-align: left;">Sales Cutoff: [event_sale_cutoff_date]</h3>
      <h3 style="text-align: left;">Main Prize: [is_main_event]</h3>
      <p>--start-additional-draw-content--</p>
      <h3 style="text-align: left;">[additional_draw_title]</h3>
      <h3 style="text-align: left;">Draw Date: [additional_draw_date]</h3>
      <p>--end-additional-draw-content--</p>
      <p>--end-event-content--</p>
      `
      initialContent = content || defaultContent

    }else {
      initialContent = content
    }
    const isContactUsEmail = location.pathname.includes("contactus");
    return (
      <Segment basic>
        <Form
          id="pages"
          loading={isLoading}
          success={xhrStatus === "success"}
          error={xhrStatus === "error"}
          onBlur={this.handleDismissPortal}
        >
        {currentPage === "shopifyticketemail" &&
        //I need a warning text here
        <div style={{marginBottom: "15px"}}>
          <p  style={{marginBottom: "15px", color: "#ff0000", fontSize: "20px",}}>Warning: Please refrain from making any modifications to this unless you have received proper training from one of our Partner Success Managers (PSMs).</p>
        <Form.Select
           style={{margin: "15px 0"}}
           label="Choose a Shopify storefront"
           name="shopify_storefront"
           value={shopifyStorefront}
           options={storefrontLists === null ? [] : storefrontLists}
           onChange={this.handleStoreSelected}
          />
          </div>}
          {!isLoading && (<CKEditor
            config={{
              toolbarGroups: [
                { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                { name: 'links', groups: [ 'links' ] },
                { name: 'insert', groups: [ 'insert' ] },
                { name: 'forms', groups: [ 'forms' ] },
                { name: 'tools', groups: [ 'tools' ] },
                { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                { name: 'others', groups: [ 'others' ] },
                '/',
                { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                { name: 'styles', groups: [ 'styles' ] },
                { name: 'colors', groups: [ 'colors' ] }
              ],
              format_tags: 'div;p;h1;h2;h3;pre',
              removeDialogTabs: 'image:advanced;link:advanced',
              extraPlugins: "justify,font,colorbutton,colordialog",
              extraAllowedContent: 'div(*)',
              removeFormatAttributes: '', //disables the removal of any attributes from the content
              allowedContent: true, // allows any content without filtering or modification.
              fullPage: false,  //indicates that the content is not a full HTML page
            }}
            onChange={this.handleChange}
            initData= {initialContent}
          />)}
          {!isLoading && <Button
            primary
            icon="save"
            content="Save"
            onClick={this.handleSubmit}
            floated="right"
            style={{ marginTop: "5px", marginBottom: "5px" }}
          />}
          <ResponseMessage status={xhrStatus} message={xhrMessage} />
        </Form>
        {currentPage === 'shopifyticketemail' ?
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan="2">
                 IMPORTANT: If you prefer to utilize the default email template for the Shopify ticket email, kindly delete this current email template and save the changes.
                 <br />
                 Once you delete this email template, the default email template will shows up again like the first time you use it.
                 <br />
                 NOTE: If this is your first time customizing a Shopify email template from the Dashboard, you will be provided with a default template that you can modify. Once you have finished customizing the template, simply click the "Save" button. From then on, the customized version of your email template will be displayed in the editor whenever you access it again.
                 <br />
                 Important: The placeholders: "--ticket-number--", "--start-ticket-content--", "--end-ticket-content--", "--start-additional-draw-content--", "--end-additional-draw-content--", "--start-event-content--", and "--end-event-content--" serve as markers in our system to determine where the rendering of event data or ticket data should begin and end. Please refrain from modifying these placeholders, but feel free to adjust their positioning within the content as needed.
                  <br />
                 Available replacements are listed below, use value(s) including [] in the editor above to construct emails.
                 <br />
                 For eg: if looking to reference the order id, use [order_id]. Please ALWAYS make sure to test the results once saved.
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>[event_id]</Table.Cell>
              <Table.Cell>Event id</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>[event_title]</Table.Cell>
              <Table.Cell>The name of the event.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>[event_draw_date_text]</Table.Cell>
              <Table.Cell>The Event Draw Date.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>[game_type]</Table.Cell>
              <Table.Cell>Game Type of the event.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>[is_main_event]</Table.Cell>
              <Table.Cell>IF this event is Main Event</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>[event_sale_cutoff_date]</Table.Cell>
              <Table.Cell>The Date when sales stop</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>[shopify_order_reference]</Table.Cell>
              <Table.Cell>Shopify Order ID</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>[order_issue_date]</Table.Cell>
              <Table.Cell>The Date when Shopify Issued this Ticket</Table.Cell>
            </Table.Row>
            {+this.context.settings.general.display_jurisdiction > 0 && <Table.Row>
              <Table.Cell>[jurisdiction]</Table.Cell>
              <Table.Cell>The state or province where this ticket was sold</Table.Cell>
            </Table.Row>}
            <Table.Row>
              <Table.Cell>[price]</Table.Cell>
              <Table.Cell>The Price of this ticket set</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>[additional_draw_title]</Table.Cell>
              <Table.Cell>Early Bird Draw title</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>[additional_draw_date]</Table.Cell>
              <Table.Cell>Early Bird Draw Date</Table.Cell>
            </Table.Row>
          </Table.Body>
          </Table>
          :
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan="2">
                Available replacements are listed below, use value(s) including [] in the editor above to construct emails.
                 For eg: if looking to reference the order id, use [order_id]. Please ALWAYS make sure to test the results once saved.
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>[support_email]</Table.Cell>
              <Table.Cell>The client support email as saved in the system.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>[client_name]</Table.Cell>
              <Table.Cell>The client name as saved in the system.</Table.Cell>
            </Table.Row>
            {!isContactUsEmail && <Table.Row>
              <Table.Cell>[order_id]</Table.Cell>
              <Table.Cell>The system assigned ID for an order.</Table.Cell>
            </Table.Row>}
            {!isContactUsEmail && <Table.Row>
              <Table.Cell>[event_title]</Table.Cell>
              <Table.Cell>The name of the event.</Table.Cell>
            </Table.Row>}
            {!isContactUsEmail && <Table.Row>
              <Table.Cell>[draw_date]</Table.Cell>
              <Table.Cell>The draw date of the event.</Table.Cell>
            </Table.Row>}
            {!isContactUsEmail && <Table.Row>
              <Table.Cell>[non_profit]</Table.Cell>
              <Table.Cell>The Non-profit assigned to the event.</Table.Cell>
            </Table.Row>}
            {!isContactUsEmail && showSubscriptionId && <Table.Row>
              <Table.Cell>[subscription_id]</Table.Cell>
              <Table.Cell>The system assigned ID for a subscription.</Table.Cell>
            </Table.Row>}
          </Table.Body>
        </Table>}
      </Segment>
    );
  }
}
CustomEmailBody.contextType = AppContext;

export default CustomEmailBody;
